module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie Paginator displays pagination.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;Paginator shownPages  = { [ 1, 2, 3, 4, 5 ] }\n           currentPage = { 2 }\n           showNext    = { true } /&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/Paginator/README.md
// module id = 375
// module chunks = 0